<template>
<div>
   <div v-on:click="changeStatus" v-b-toggle="id"  :id="'head' + id" class="pl-3 filter">
        <div class="d-flex">
            <img class="pastcla" :id="'first-img'+id" src="https://static.zopone.com.br/img/realestate/icon/icon_pasta.svg">
            <img class="pastcla" :id="'second-img'+id" src="https://static.zopone.com.br/img/realestate/icon/icon_pasta_aberta.svg">
            <p class="name-title-cla" :id="'name-title'+id">{{title}}</p>
        </div>
        <i  :id="'first-angel'+id"  class="fas fa-angle-down mr-3  angel"></i>
        <i   :id="'second-angel'+id" class="fas fa-angle-up mr-3  angel-down"></i>
    </div>
    <b-collapse v-model="isOpen" :id="id" :accordion="accordion ? accordion:id" role="tabpanel">
              <slot></slot>
    </b-collapse>
</div>
</template>

<script>
export default {
  name: 'FilterGroupPaste',
  props: ['id', 'title', 'accordion'],
  data () {
    return {
      changeAngel: false,
      isOpen: false
    }
  },
  watch: {
    isOpen (newvalue) {
      this.$emit('selectFilterParamWatch')
      let item = document.getElementById('head' + this.id)
      let title = document.getElementById('name-title' + this.id)
      let firstImg = document.getElementById('first-img' + this.id)
      let SecondImg = document.getElementById('second-img' + this.id)
      let firstAngel = document.getElementById('first-angel' + this.id)
      let secondAngel = document.getElementById('second-angel' + this.id)
      if (newvalue === false) {
        item.classList.remove('filter-active')
        firstImg.style.display = ''
        SecondImg.style.display = 'none'
        firstAngel.style.display = ''
        secondAngel.style.display = 'none'
        title.classList.remove('name-title-cla-active')
        title.classList.add('name-title-cla')
        item.classList.add('filter')
      } else {
        this.$emit('filterById', this.id)
        item.classList.remove('filter')
        title.classList.remove('name-title-cla')
        title.classList.add('name-title-cla-active')
        firstImg.style.display = 'none'
        SecondImg.style.display = ''
        firstAngel.style.display = 'none'
        secondAngel.style.display = ''
        item.classList.add('filter-active')
      }
    }
  },

  mounted () {
    this.initialClass()
  },
  methods: {
    changeStatus (e) {
      this.$emit('selectFilterParam')
      let item = document.getElementById('head' + this.id)
      let title = document.getElementById('name-title' + this.id)
      let firstImg = document.getElementById('first-img' + this.id)
      let SecondImg = document.getElementById('second-img' + this.id)
      let firstAngel = document.getElementById('first-angel' + this.id)
      let secondAngel = document.getElementById('second-angel' + this.id)
      if (item.classList.contains('filter-active')) {
        item.classList.remove('filter-active')
        firstImg.style.display = ''
        SecondImg.style.display = 'none'
        firstAngel.style.display = ''
        secondAngel.style.display = 'none'
        title.classList.remove('name-title-cla-active')
        title.classList.add('name-title-cla')
        item.classList.add('filter')
      } else {
        item.classList.remove('filter')
        title.classList.remove('name-title-cla')
        title.classList.add('name-title-cla-active')
        firstImg.style.display = 'none'
        SecondImg.style.display = ''
        firstAngel.style.display = 'none'
        secondAngel.style.display = ''
        item.classList.add('filter-active')
      }
    },
    changeOpen () {
      this.isOpen = false
    },
    initialClass () {
      document.getElementById('second-img' + this.id).style.display = 'none'
      document.getElementById('second-angel' + this.id).style.display = 'none'
    },
    updateStatus () {
      let item = document.getElementById('head' + this.id)
      let title = document.getElementById('name-title' + this.id)
      let firstImg = document.getElementById('first-img' + this.id)
      let SecondImg = document.getElementById('second-img' + this.id)
      let firstAngel = document.getElementById('first-angel' + this.id)
      let secondAngel = document.getElementById('second-angel' + this.id)
      if (!this.collapseStatus) {
        item.classList.remove('filter-active')
        firstImg.style.display = ''
        SecondImg.style.display = 'none'
        firstAngel.style.display = ''
        secondAngel.style.display = 'none'
        title.classList.remove('name-title-cla-active')
        title.classList.add('name-title-cla')
        item.classList.add('filter')
      } else {
        item.classList.remove('filter')
        title.classList.remove('name-title-cla')
        title.classList.add('name-title-cla-active')
        firstImg.style.display = 'none'
        SecondImg.style.display = ''
        firstAngel.style.display = 'none'
        secondAngel.style.display = ''
        item.classList.add('filter-active')
      }
    }
  }

}
</script>

<style scoped>

    .filter{
        display: flex;
        padding: 10px;
        justify-content: space-between;
        background-color: #E9ECEF;
        border-radius: 8px;
        cursor: pointer;

    }
    .filter-active{
        display: flex;
        padding: 10px;
        justify-content: space-between;
        background-color: #008148;
        border-radius: 8px;
        cursor: pointer;

    }
    .name-title-cla{
        font-size: 15px;
        font-weight: bold;
        color: #008148;
        padding: 0px;
        margin: 0px;
        margin-top: 3px;
        margin-left: 5px;

    }
    .name-title-cla-active{
        font-size: 15px;
        font-weight: bold;
        color: white;
        padding: 0px;
        margin: 0px;
        margin-top: 3px;
        margin-left: 5px;
    }
    .angel{
        font-size: 20px;
        color: #008148;

    }
    .angel-down{
        font-size: 20px;
        color: white;
    }
    .pastcla{
        width: 16px;
        height: 20px;
        padding-top: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/components/FilterGroupPaste.vue